"use strict";
// tslint:disable: no-any
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Source = /** @class */ (function () {
    function Source(settings) {
        this.settings = [];
        this.settings = settings || [];
    }
    Source.prototype.select = function (key) {
        if (!key) {
            return __spreadArrays(this.settings);
        }
        return this.settings.filter(function (setting) { return setting.key === key; });
    };
    return Source;
}());
exports.Source = Source;
//# sourceMappingURL=source.js.map